import React from "react"
import ResponseAdditionCode from "./ResponseAdditionCode"
import ResponseAdditionText from "./ResponseAdditionText"

const AdditionList = ({action, additions, setAdditions}) =>{
    if(!action || !action.additions?.length) return null
    const getCurrAddition = (actionAdditionId) =>{
        if (!additions?.length) return null
        const currAddition = additions.filter(addition=>actionAdditionId===addition.qid)
        return  currAddition?.length? currAddition[0] : null
    }
    const updateAdditions =(addition) =>{
        const filtered = (additions?.length) ? additions.filter(c=>c.qid !== addition.qid) : []
        setAdditions([...filtered, addition])
    }
    return (<>
       { action.additions.map(actionAddition=>{
            return <React.Fragment key={actionAddition._id}>
                    {action.type==="Text"&& <ResponseAdditionText  actionAddition={actionAddition} responseAddition={getCurrAddition(actionAddition._id)} updateAdditions={updateAdditions} />}
                    {action.type==="Code"&& <ResponseAdditionCode  actionAddition={actionAddition} responseAddition={getCurrAddition(actionAddition._id)} updateAdditions={updateAdditions} />}
                    {/* {type==="File"&& <ResponseFile action={action} body={body} setBody={setBody} />} */}
                    </React.Fragment>
        })
       }
    </>)
}
export default AdditionList